import { useSelector } from "react-redux";
import useLogin from "./useLogin";
import SetupAction from "@common/redux/actions/SetupAction";
import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";
import SessionClient from "@common/api/SessionClient";
import ComplianceSessionClient from "@common/api/ComplianceSessionClient";
import LinkSessionAction from "@common/redux/actions/LinkSessionAction";
import { handleError } from "../helpers/error";

const useLinkSession = () => {
  const { mode } = useSelector((store) => SetupAction.getStatePath(store));
  const [{ isDesktop }] = useLogin();
  const { sessionkey } = useSelector((state) => state.logIn ?? {});

  const handleLinkSession = () => {};

  const getComplianceSessionsByGuids = (title = "", sessionGuids = []) => {
    if (isDesktop) sessionStorage.setItem("token", sessionkey);

    SessionalDetailsAction.dispatch({ title });

    const filteredSessions =
      sessionGuids?.filter((x) => x.toString().length > 1) ?? [];
    if (sessionGuids && filteredSessions.length > 0) {
      const fnSessions = isDesktop
        ? ComplianceSessionClient.GetSessionsByGuids(sessionGuids, 1)
        : SessionClient.SessionByGuid(sessionGuids);

      fnSessions
        .then((response) => {
          LinkSessionAction.dispatch({
            linkedSessionData: response.grid.data,
          });
          SessionalDetailsAction.dispatch(response);
        })
        .catch(handleError);
    } else {
      LinkSessionAction.dispatch({ linkedSessionData: [] });
    }
  };

  return {
    mode,
    handleLinkSession,
    getComplianceSessionsByGuids,
  };
};

export default useLinkSession;
